// extracted by mini-css-extract-plugin
export default {"font-renta":"ChartsPage_font-renta__UhiZe","question-container":"ChartsPage_question-container__zbT2K"};